import { Roles } from '../data/auth/roles';

export enum UserRoles {
  SuperAdmin = 'SuperAdmin',
  RestaurantManager = 'RestaurantManager',
  KitchenStaff = 'KitchenStaff',
  RestaurantWaiter = 'RestaurantWaiter',
}

export const isRestaurantManager = (roles?: Roles | undefined) =>
  roles && roles.restaurantManager.length > 0;

export const isSuperAdmin = (roles?: string[] | undefined) =>
  roles &&
  roles.some((role) => {
    const userRole = role as UserRoles;

    if (!Object.values(UserRoles).includes(userRole)) {
      console.warn(`Invalid role: ${role}`);
      return false;
    }

    return [UserRoles.SuperAdmin].includes(userRole);
  });
